import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NotificationService } from '@carm/_core/notification-mgt/facade/notifcation.service';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
    selector: 'carm-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
  })

  export class SnackbarComponent implements OnInit, OnDestroy {

  remainingTime: { minutes: number; seconds: number } = { minutes: 0, seconds: 0 };
  private timerSubscription: Subscription | null = null;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, private notificationService: NotificationService) {
  }

  ngOnInit() {
     if (this.data.showTimer){
      this.startTimer();
     }
  }

  private startTimer() {
    this.updateRemainingTime(); // Initial calculation

    this.timerSubscription = interval(1000).subscribe(() => {
      this.updateRemainingTime();
    });
  }

  private stopTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  private updateRemainingTime() {
    const deploymentTime = localStorage.getItem('nextDeploymentTime');
    if (deploymentTime) {
      const deploymentDate = new Date(deploymentTime);
      const now = new Date();
      const remainingMilliseconds = deploymentDate.getTime() - now.getTime();
      const remainingSeconds = Math.max(0, Math.floor(remainingMilliseconds / 1000));
      this.remainingTime.minutes = Math.floor(remainingSeconds / 60);
      this.remainingTime.seconds = remainingSeconds % 60;
    }
  }

  closeSnackbar() {
        this.notificationService.clearNotification();
  }

  ngOnDestroy() {
      this.stopTimer();
  }
}
